import { ServiceBase, Result } from "./ServiceBase";

export default class UtilityService extends ServiceBase {

    public static async rebuildShortCodes(): Promise<Result<boolean>> {

        var result = await this.requestJson<boolean>({
            url: `/api/utility/rebuildshortcodes`,
            method: "POST"            
        });

        return result;
    }

    public static async updateInventoryPrices(): Promise<Result<boolean>> {

        var result = await this.requestJson<boolean>({
            url: `/api/utility/updateinventoryprices`,
            method: "POST"
        });

        return result;
    }

    public static async downloadPartnerLog(partnerName): Promise<Result<string>> {

        var result = await this.requestJson<string>({
            url: `/api/utility/downloadPartnerLog?partnerName=` + partnerName,
            method: "POST"
        });

        return result;
    }
}
